/* globals $, ko, _, Modal, Toasts */

$(function () {
    "use strict";

    var EMPTY_AVATAR_URL = '//css.nevesta.info/images/global/no-avatar-exp.png';

    var $root = $('#contact-overlay');
    var getForm = function () {
        return $root.find('.contact-overlay__form');
    };

    function generateBackgroundString (url) {
        return 'url(' + url + ')';
    }

    var ContactOverlayViewModel = new function () {
        var self = this;

        self.id = ko.observable(undefined);
        self.name = ko.observable(undefined);
        self.location = ko.observable(undefined);
        self.type = ko.observable(undefined);
        self.is_self = ko.observable(false);

        self.subject = ko.observable('');
        self.charge_amount = ko.observable(0);
        self.send_action = ko.observable('');
        self.not_enough_money = ko.observable(false);

        self.phone = ko.observable(undefined);
        self.forwarding = ko.observable(undefined);
        self.phone_hidden = ko.computed(function () {
            return (_(self.phone()).first(6) || []).join('') + ' <span class="text_color_muted">XXX-XX-XX</span>';
        });
        self.vk = ko.observable(undefined);
        self.vk_url = ko.observable(undefined);
        self.fb = ko.observable(undefined);
        self.fb_url = ko.observable(undefined);
        self.instagram = ko.observable(undefined);
        self.instagram_url = ko.observable(undefined);
        self.website = ko.observable(undefined);
        self.website_url = ko.observable(undefined);
        self.avatar_url = ko.observable(generateBackgroundString(EMPTY_AVATAR_URL));
        self.background_image_url = ko.observable(undefined);

        self.loading = ko.observable(true);
        self.error = ko.observable('');
        self.submitForm = submitForm;
        self.submitting = ko.observable(false);
    };

    function resetData () {
        var $form = getForm();
        $form.trigger('Parsley::Reset');
        $form.find('input, textarea').each(function () {
            $(this).val('');
        });

        ContactOverlayViewModel.loading(true);
        ContactOverlayViewModel.id(undefined);
        ContactOverlayViewModel.name(undefined);
        ContactOverlayViewModel.location(undefined);
        ContactOverlayViewModel.type(undefined);
        ContactOverlayViewModel.is_self(false);

        ContactOverlayViewModel.subject('');
        ContactOverlayViewModel.charge_amount(0);
        ContactOverlayViewModel.send_action('');
        ContactOverlayViewModel.not_enough_money(false);

        ContactOverlayViewModel.phone(undefined);
        ContactOverlayViewModel.vk(undefined);
        ContactOverlayViewModel.instagram(undefined);
        ContactOverlayViewModel.fb(undefined);
        ContactOverlayViewModel.website(undefined);
        ContactOverlayViewModel.avatar_url(generateBackgroundString(EMPTY_AVATAR_URL));
        ContactOverlayViewModel.background_image_url(undefined);

        ContactOverlayViewModel.error('');
        ContactOverlayViewModel.submitting(false);
    }

    function updateData (data) {

        var newData = data;

        if (Boolean(newData.avatar_url)) {
            newData.avatar_url = generateBackgroundString(newData.avatar_url);
        }
        else {
            newData.avatar_url = generateBackgroundString(EMPTY_AVATAR_URL);
        }

        if (Boolean(newData.background_image_url)) {
            newData.background_image_url = generateBackgroundString(newData.background_image_url);
        }

        _(newData).forEach(function(value, key) {
            if (_(ContactOverlayViewModel[key]).isFunction()) {
                ContactOverlayViewModel[key](value);
            }
        });
    }

    function openContactOverlay (url, vpUrl, showPhone) {
        Modal.openModal($root, vpUrl);

        $.getJSON(url)
        .success(function (data) {
            ContactOverlayViewModel.loading(false);
            updateData(data);
            if (showPhone) {
                $(document).off('PhoneChip::Processed.contact-overlay');
                $(document).on('PhoneChip::Processed.contact-overlay', function (event, $phone) {
                    $phone.trigger('click');
                });
            }
            $(document).trigger('PhoneChip::Process');
            $(document).trigger('Parsley::Init');

            // Пока не удалять - нужно для фокуса на первом поле в оверлее
            // $(document).trigger('ContactOverlay::focusInput');
        })
        .fail(function (data) {
            var error = 'Что-то пошло не так, пожалуйста попробуйте позже';
            if (Boolean(data.responseJSON) && _(data.responseJSON.error).isString()) {
                error = data.responseJSON.error;
            }
            ContactOverlayViewModel.error(error);
        });
    }

    function submitForm () {
        var $form = getForm();

        if ($form.data('validator').isFormValid()) {

            var sendUrl = $form.attr('action');
            ContactOverlayViewModel.submitting(true);

            $.post(sendUrl, $form.serialize())
                .fail(function (data) {
                    ContactOverlayViewModel.submitting(false);

                    if (!_(data.responseJSON).isObject()) {
                        Toasts.pushToast('Что-то пошло не так, попробуйте позднее', 'fail');
                        return false;
                    }
                    var resp = data.responseJSON;

                    var error;
                    if (_(resp.error).isString()) {
                        error = resp.error;
                    }

                    if (_(resp.errors).isObject()) {

                        if (_(resp.errors.global).isString()) {
                            error = resp.errors.global;
                        }
                    }

                    if (_(error).isString()) {

                        if (ContactOverlayViewModel.type() === 'firm') {
                            var $enter = $('.b-enter');

                            if (data.responseJSON.error === 'user_already_exists' && $enter.length > 0) {
                                Modal.closeModal($root);
                                $enter.find('[name*=email]').val($form.find('[name*=email]').val());
                                $enter.trigger('openScreen', ['auth-email-exists']);
                            }
                            else {
                                Toasts.pushToast(error, 'fail');
                            }
                        }
                        else {
                            Toasts.pushToast(error, 'fail');
                        }
                    }
                })
                .success(function (data) {
                    if (data.redirect) {
                        document.location = data.redirect;
                    }
                    else {

                        if (ContactOverlayViewModel.type() === 'firm') {
                            Toasts.pushToast('Запрос отправлен', window.MediaQueryState.phones ? 'success' : 'success_huge');
                        }
                        else {
                            Toasts.pushToast('Сообщение отправлено', 'success');
                        }

                        Modal.closeModal($root);
                    }
                });
        }
    }

    // Пока не удалять - нужно для фокуса на первом поле в оверлее
    // $(document).on('ContactOverlay::focusInput', function () {
    //     $root.find('input, textarea').not(':hidden').eq(0).focus();
    // });

    $(document).on('click', '.phone-chip__show-more', function () {
        $('.contact-overlay__message').toggleClass('layout__none');
    });

    $(document).on('Modal::close', function (event, $modal) {
        if ($($modal).is($root)) {
            resetData();
            $(document).off('PhoneChip::Processed.contact-overlay');
        }
    });

    $(document).on('click.ContactOverlay', '.i-open-contact-overlay', function (event) {
        event.preventDefault();

        var $this = $(this);

        var url = $this.data('get-contact-url');
        var vpUrl = $this.data('vp-url');
        var showPhone = $this.data('show-phone') || Modernizr.touch;

        if (Boolean(url)) {
            openContactOverlay(url, vpUrl, showPhone);
        }
    });

    if ($root.length > 0) {
        ko.applyBindings(ContactOverlayViewModel, $root[0]);
    }
});
